import lodash from 'lodash'

const actions = {
  setActiveInput({ commit }, inputName) {
    commit('setActiveInputName', inputName)
  },
  clear({ commit }) {
    commit('clear')
  },
  addServer({ state, commit }) {
    commit('setServer', state.defaultServer)
  },
  setGeneralSettings({ commit }, settings) {
    commit('setGeneralSettings', settings)
  },
  async refetchServer({ dispatch, state }) {
    return await dispatch('findServer', state.server.serverId)
  },
  addNewInput({ commit, state: { defaultServer, server } }) {
    const input = lodash.cloneDeep(defaultServer.inputs[0])
    // Create a uniq input name with index
    let index = server.inputs.length + 1
    let name = null
    do {
      name = `input${index.toString().length === 1 ? '0' + index : index}`
      index += 1
    } while (server.inputs.find(({ inputName }) => inputName === name))
    input.inputName = name
    input.isNew = true
    commit('addInput', input)
  },
  addNewPreprocessor({ commit, state: { defaultServer, activeInputName } }, index) {
    const processor = lodash.cloneDeep(defaultServer.inputs[0].preProcessors[0])
    processor.isNew = true
    commit('addPrepocessor', [activeInputName, index, processor])
  },
  addNewPostprocessor({ commit, state: { defaultServer, activeInputName } }, index) {
    const processor = lodash.cloneDeep(defaultServer.inputs[0].postProcessors[0])
    processor.isNew = true
    commit('addPostprocessor', [activeInputName, index, processor])
  },
  addNewOutput({ commit, state: { defaultServer, activeInputName } }) {
    const output = lodash.cloneDeep(defaultServer.inputs[0].output[0])
    output.isNew = true
    commit('addOutput', [activeInputName, output])
  },
  saveProcessorOnStore({ state: { activeInputName }, commit }, [index, processor]) {
    if (processor.__typename === 'PreProcessor') {
      commit('savePreprocessor', [activeInputName, index, processor])
    } else if (processor.__typename === 'PostProcessor') {
      commit('savePostprocessor', [activeInputName, index, processor])
    }
  },
  saveOutputOnStore({ state: { activeInputName }, commit }, [index, output]) {
    commit('saveOutput', [activeInputName, index, output])
  },
  removeInput(
    {
      commit,
      state: {
        server: { inputs, serverId }
      },
      dispatch
    },
    inputName
  ) {
    if (
      lodash.find(inputs, {
        inputName
      }).isNew
    ) {
      commit('removeInput', inputName)
    } else {
      dispatch('removeInputOnServer', {
        inputName,
        serverId
      })
    }
  },
  removePreprocessor(
    {
      commit,
      state: {
        server: { inputs, serverId },
        activeInputName: inputName
      },
      dispatch
    },
    index
  ) {
    if (
      lodash.find(inputs, {
        inputName
      }).preProcessors[index].isNew
    ) {
      commit('removePreprocessor', [inputName, index])
    } else {
      dispatch('removeProcessorOnServer', {
        inputName,
        serverId,
        sectionIndex: index,
        sectionType: 'pre-processors'
      })
    }
  },
  async removePostprocessor(
    {
      commit,
      state: {
        server: { inputs, serverId },
        activeInputName: inputName
      },
      dispatch
    },
    index
  ) {
    if (
      lodash.find(inputs, {
        inputName
      }).postProcessors[index].isNew
    ) {
      commit('removePostprocessor', [inputName, index])
    } else {
      return await dispatch('removeProcessorOnServer', {
        inputName,
        serverId,
        sectionIndex: index,
        sectionType: 'post-processors'
      })
    }
  },
  removeOutput(
    {
      commit,
      state: {
        server: { inputs, serverId },
        activeInputName: inputName
      },
      dispatch
    },
    index
  ) {
    if (
      lodash.find(inputs, {
        inputName
      }).output[index].isNew
    ) {
      commit('removeOutput', [inputName, index])
    } else {
      dispatch('removeProcessorOnServer', {
        inputName,
        serverId,
        sectionIndex: index,
        sectionType: 'output'
      })
    }
  }
}
export default actions
